import { createContext, useContext, type ReactNode } from 'react'

/**
 * Whether the Hub's boot screen already painted placeholders for the tab that
 * is opening (RP-5936).
 *
 * Sections read this to decide whether to replay the 150ms anti-flash delay
 * when they mount. After a boot skeleton the delay would blank a column the
 * viewer is already looking at, so they render their skeleton immediately
 * instead and the handoff is seamless.
 *
 * Defaults to `false` with no provider, so a section rendered on its own — in
 * a test, or by a host that mounts it directly — keeps the normal contract.
 */
const BootSkeletonContext = createContext(false)

export function BootSkeletonProvider({
  hasBootSkeleton,
  children,
}: {
  hasBootSkeleton: boolean
  children: ReactNode
}) {
  return (
    <BootSkeletonContext.Provider value={hasBootSkeleton}>
      {children}
    </BootSkeletonContext.Provider>
  )
}

export function useHasBootSkeleton(): boolean {
  return useContext(BootSkeletonContext)
}
